module.exports = __webpack_public_path__ + "img/manhattan.c082a6fa.jpg";